import _ from 'lodash';
import { CorrectDatepicker, moment, initDycolor } from '~';
import { mapActions, mapGetters } from 'vuex';
import FillStatusSummary from '@/components/rabbit/fill-status-summary/FillStatusSummary.vue';

initDycolor('campaign-start-date', require(`${process.env.DYCOLOR_REQUIRE}./CampaignStartDate.scss`)); // eslint-disable-line

export default {
  components: {
    datepicker: CorrectDatepicker,
    'fill-status-summary': FillStatusSummary,
  },
  props: ['readonly'],
  data() {
    return {
      loading: false,
      internalValue: null,
    };
  },
  methods: {
    ...mapActions('campaign', ['setStartDate']),
    openPopup() {
      if (!this.readonly) {
        this.$refs.modal.show();
        this.internalValue = this.campaign.start_date;
      }
    },
    changeStartDate() {
      this.loading = true;

      const newStartDate = moment(this.internalValue).format('YYYY-MM-DD');

      this.setStartDate(newStartDate)
        .then(() => {
          this.loading = false;
          this.$toast.success({ message: this.$t('pos.campaign.start-date-changed') });
          this.cancel();
        })
        .catch(error => {
          this.loading = false;
          this.$toast.error({ message: error });
        });
    },
    cancel() {
      this.$refs.modal.hide();
    },
  },
  computed: {
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    startDate() {
      const date = _.get(this.campaign, 'start_date', null);
      if (date) {
        return this.$t('fn.date', { timestamp: date });
      }
      return date;
    },
    disabled() {
      return {
        from: this.campaign.maxStartDate,
        to: this.campaign.minStartDate,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/campaign-start-date/CampaignStartDate.js